import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import GenericButton from "../Custom/GenericButton";

const TaskCard = ({ task, t, handleView }) => {
  const fields = [
    { label: t("Program"), value: task.program_name || t("N/A") },
    { label: t("Task"), value: task.name || t("N/A") },
    { label: t("Start Date"), value: task.start_date || t("N/A") },
    { label: t("Due Date"), value: task.due_date || t("N/A") },
  ];

  return (
    <Box
      sx={{
        mb: 2,
        boxShadow: "none",
        border: "1px solid #A5A5A5",
        padding: handleView ? "16px 16px 0 16px" : "16px",
        borderRadius: "4px",
      }}
    >
      <Box mt={1}>
        {fields.map((field) => (
          <Grid key={field.label} container>
            <Grid item xs={6}>
              <Typography variant="body2">
                <strong>{field.label} : </strong>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">{field.value}</Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
      {handleView && (
        <Box mt={2}>
          <GenericButton
            backgroundColor={"#4CAF50"}
            fontColor={"#fff"}
            fontSize={"14px"}
            padding={"7px 10px"}
            onClick={handleView}
          >
            {t("View")}
          </GenericButton>
        </Box>
      )}
    </Box>
  );
};

export default TaskCard;
